import { FunctionComponent, ReactNode, SyntheticEvent } from 'react';
import { FelaCSS, TSizeValues } from '@bridebook/ui';
import FelaButton from '../../../../components/fela/Button';
import IconChevron from '../../../../components/svg/icon-chevron';
import mergeStyles from '../../../../fela-utils/merge-styles';
import componentStyles from './button-chevron.style';

interface IProps {
  direction: string;
  w?: TSizeValues;
  h?: TSizeValues;
  icon?: ReactNode;
  disabled?: boolean;
  loading?: boolean;
  name?: string;
  id?: string;
  onClick?: (e: SyntheticEvent<any>) => any;
  ref?: Function;
  style?: FelaCSS;
  color?: string;
  rounded?: boolean;
  iconWidth?: number;
}

const ButtonChevron: FunctionComponent<IProps> = ({
  w,
  h,
  disabled,
  loading,
  name,
  id,
  onClick,
  ref,
  style = {},
  direction,
  color,
  rounded,
  iconWidth,
  ...restProps
}) => {
  const styles = componentStyles({ direction, w, h, rounded });

  return (
    <FelaButton
      style={mergeStyles([styles.wrapper, style])}
      data-name={name || 'button-chevron'}
      onPress={onClick}
      ref={ref}
      id={id}
      disabled={disabled}
      {...restProps}>
      <IconChevron
        width={iconWidth ?? 16}
        color={disabled ? 'space08' : 'space'}
        style={styles.chevronWrap}
      />
    </FelaButton>
  );
};

export default ButtonChevron;
